import dayjs from "utils/dayjs";
import Role from "../enums/Role";

export const buildNextTransfers = (
  {
    transferDate,
    isRepeatJob,
    repeatOnDay,
    repeatDayOfMonth,
    repeatDayOfWeek,
    repeatWeekday,
    repeatNeverEnd,
    repeatEndOn,
  }: any,
  numberTransfer: number,
) => {
  let i = 0;
  let nextDate = dayjs(transferDate);
  let endDate = dayjs(repeatEndOn);
  let nextDates = [];

  do {
    if (!repeatOnDay) {
      nextDate = nextDate.startOf("month").day(repeatWeekday);
      if (nextDate.date() > 7) {
        nextDate = nextDate.add(7, "day");
      }
      nextDate = nextDate.add(repeatDayOfWeek - 1, "week");
    } else {
      let tmpDay = repeatDayOfMonth;
      let tmpMonth = nextDate.clone();

      if (repeatDayOfMonth > tmpMonth.endOf("month").get("date")) {
        tmpDay = tmpMonth.endOf("month").get("date");
      }

      nextDate = nextDate.set("date", tmpDay);
    }

    if (dayjs(transferDate).startOf("day").isBefore(nextDate)) {
      nextDates.push(nextDate.toDate());
    }
    nextDate = nextDate.add(1, "month");
    i += 1;
  } while (
    i < numberTransfer &&
    (repeatNeverEnd ||
      (!repeatNeverEnd && isRepeatJob && nextDate.isBefore(endDate)))
  );

  return nextDates;
};

export const isPlatformAccount = (role: Role) => {
  return role === Role.PlatformAdmin || role === Role.PlatformOwner;
};

export const isManager = (role: Role) => {
  return role === Role.Manager;
};

export const isEmployee = (role: Role) => {
  return role === Role.Employee || role === Role.Contractor;
};
